import axios from "axios";

console.log(process.env.NODE_ENV);
export default process.env.NODE_ENV == "production"
    ? axios.create({
        //production 환경 (AWS EC2)
        // baseURL: "https://wasBayerFarmSSO.zplab.co.kr"
        baseURL: "https://was.farmpartner.bayer.co.kr"
    })
    : axios.create({
        //development 환경
        // baseURL: "http://localhost:8802",
        // baseURL: "https://wasBayerFarmSSO.zplab.co.kr"
        baseURL: "https://was.farmpartner.bayer.co.kr"
    });